/**
 * BBD-73 — share responses can now be partial.
 *
 * `permissions/create/` and `permissions/edit/` still return 201, but they skip
 * any address that is on either side of a block: one the sharer blocked, or one
 * belonging to someone who blocked the sharer. The skipped addresses come back
 * in `blocked_emails`.
 *
 * The wording deliberately does not say which direction the block runs in —
 * telling a sharer "they blocked you" would leak the other person's action.
 */
export function notifyBlockedShareRecipients(data) {
  const blocked = data && data.blocked_emails;
  if (!blocked || blocked.length === 0) return false;

  const list = blocked.join(', ');
  window.alert(
    `The document was shared, but these addresses were skipped because of a block: ${list}.\n\n` +
    `If you blocked one of them, you can unblock it from Account → Blocked Emails.`
  );
  return true;
}

/** Read a share response's JSON without throwing on an empty or non-JSON body. */
export async function readShareResponse(response) {
  try {
    return await response.json();
  } catch (e) {
    return {};
  }
}
